import React, { useEffect, useState } from 'react';
import './Loader.css';

const Loader = ({ onLoadComplete }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time (adjust as needed)
    const timer = setTimeout(() => {
      setIsLoading(false);
      setTimeout(() => {
        onLoadComplete();
      }, 800); // Wait for fade out animation
    }, 3500); // Total loading time

    return () => clearTimeout(timer);
  }, [onLoadComplete]);

  return (
    <div className={`loader-container ${!isLoading ? 'fade-out' : ''}`}>
      <div className="loader-content">
        <div className="logo-letter-wrapper">
          <img src="/assets/logo.png" alt="R" className="logo-letter-img" />
        </div>
        <div className="loader-bar">
          <div className="loader-progress"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
